import {
    Button,
    ButtonGroup,
    Card,
    CardBody,
    Divider,
    Flex,
    Stack,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Textarea,
    Th,
    Thead,
    Tr,
} from "@chakra-ui/react";
import React from "react";
import styled from "styled-components";
import { deletePostByAdmin } from "../../../services/CustomerAPI";

const HoverDiv = styled.div`
    &:hover {
        color: red;
        cursor: pointer;
    }
`;

export const AdminComplement = (props) => {
    const questionBeforeDelete = () => {
        if (window.confirm("정말 삭제하시겠습니까?")) {
            handleFormDelete();
        } else {
            alert("게시물 삭제를 취소합니다.");
        }
    };

    const handleFormDelete = async () => {
        try {
            await deletePostByAdmin(props.id);
            alert("게시물이 성공적으로 삭제되었습니다.");
            props.goList();
        } catch (error) {
            alert("게시물 삭제에 실패하였습니다!");
        }
    };

    return (
        <Flex
            mt="20px"
            justifyContent="center"
            justifyItems="center"
            alignContent="center"
            alignItems="center"
            direction="column"
        >
            <Card w="80%" variant="outline">
                <CardBody>
                    <Divider />
                    <Stack textAlign="center">
                        <Text pb="5px" mt="5px" as="b" fontSize="3xl" bgColor="#FFE4E4">
                            {props.complement.title}
                        </Text>
                    </Stack>
                    <TableContainer>
                        <Table size="sm">
                            <Thead h="0">
                                <Tr>
                                    <Th w="25%" color="black" textAlign="center" fontSize="xl"></Th>
                                    <Th w="75%" color="black" textAlign="center" fontSize="xl"></Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                <Tr w="50%" direction="row">
                                    <Td textAlign="center">
                                        <Text as="b" fontSize="xl">
                                            작성자
                                        </Text>
                                    </Td>
                                    <Td textAlign="start" fontSize="xl">
                                        <Text>{props.complement.publisher}</Text>
                                    </Td>
                                </Tr>
                                {props.complement.publisher !== "관리자" && (
                                    <Tr w="50%" direction="row">
                                        <Td textAlign="center">
                                            <Text as="b" fontSize="xl">
                                                비밀번호
                                            </Text>
                                        </Td>
                                        <Td textAlign="start" fontSize="xl">
                                            <Text>{props.complement.password}</Text>
                                        </Td>
                                    </Tr>
                                )}
                                {props.complement.publisher !== "관리자" && (
                                    <Tr w="50%" direction="row">
                                        <Td textAlign="center">
                                            <Text as="b" fontSize="xl">
                                                이메일
                                            </Text>
                                        </Td>
                                        <Td textAlign="start" fontSize="xl">
                                            <Text>{props.complement.email}</Text>
                                        </Td>
                                    </Tr>
                                )}
                                {props.complement.publisher !== "관리자" && (
                                    <Tr w="50%" direction="row">
                                        <Td textAlign="center">
                                            <Text as="b" fontSize="xl">
                                                비밀글 여부
                                            </Text>
                                        </Td>
                                        <Td textAlign="start" fontSize="xl">
                                            <Text>{props.complement.secret ? "○" : "×"}</Text>
                                        </Td>
                                    </Tr>
                                )}
                                <Tr w="50%" direction="row">
                                    <Td textAlign="center">
                                        <Text as="b" fontSize="xl">
                                            등록일
                                        </Text>
                                    </Td>
                                    <Td textAlign="start" fontSize="xl">
                                        <Text>
                                            {props.complement.createdAt
                                                ? props.complement.createdAt.substr(0, 10)
                                                : props.complement.createdAt}
                                        </Text>
                                    </Td>
                                </Tr>
                                <Tr w="50%">
                                    <Td textAlign="center">
                                        <Text as="b" fontSize="xl">
                                            파일
                                        </Text>
                                    </Td>
                                    <Td
                                        textAlign="start"
                                        fontSize="xl"
                                        color={props.complement.file ? "blue" : "black"}
                                    >
                                        <div>
                                            {props.complement.file ? (
                                                <HoverDiv>
                                                    <div>
                                                        <a
                                                            href={props.complement.file}
                                                            target="_blank"
                                                            download
                                                            rel="noreferrer"
                                                        >
                                                            {props.complement.file.split("/")[4]}
                                                        </a>
                                                    </div>
                                                </HoverDiv>
                                            ) : (
                                                <p>등록된 파일 없음</p>
                                            )}
                                        </div>
                                    </Td>
                                </Tr>
                            </Tbody>
                        </Table>
                        <Flex h="250px" p="10px" fontSize="xl">
                            <Textarea
                                width="100%"
                                fontSize="xl"
                                minH="230px"
                                maxH="230px"
                                value={props.complement.content}
                                isReadOnly={true}
                                focusBorderColor="gainsboro"
                            ></Textarea>
                        </Flex>
                        <Divider />
                    </TableContainer>
                </CardBody>
            </Card>

            <ButtonGroup mt="10px" justifyContent="center" spacing="3">
                <Button onClick={() => questionBeforeDelete()} colorScheme="red" size="lg" fontSize="2xl">
                    삭제
                </Button>
                {props.complement.admin && (
                    <Button onClick={() => props.setComponentNumber(1)} colorScheme="green" size="lg" fontSize="2xl">
                        편집
                    </Button>
                )}
                <Button onClick={() => props.goList()} colorScheme="gray" size="lg" fontSize="2xl">
                    목록
                </Button>
            </ButtonGroup>
        </Flex>
    );
};
